module.exports = __webpack_public_path__ + "7b65755dccd4b8cc18de3a266161072a.png";